import _extends from "@babel/runtime/helpers/esm/extends";
import { EMessageChannel } from './message';
import { fieldsMessageRequest } from './message-request';
export const fieldsInboundMessageRequest = _extends({}, fieldsMessageRequest, {
  channel: {
    type: 'Option',
    values: EMessageChannel
  }
});